__turbopack_context__.v({
  "OverflowHidden": "lJnBtW_OverflowHidden",
  "PlattanDesktop": "lJnBtW_PlattanDesktop",
  "PlattanMobile": "lJnBtW_PlattanMobile",
  "Root": "lJnBtW_Root",
});
